import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import AppButton from "../../../components/AppButton";
import AppDialog from "../../../components/AppDialog";
import Rocket from "../../../assets/logo/rocket.svg";
import { Container } from "@mui/system";
import config from "../../../utils/config";
import { useNavigate } from "react-router-dom";

export default function KyconHold({
  showKyt,
  setShowKyt,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <AppDialog show={showKyt} onChangeShow={setShowKyt} showClose={false}>
      <Container
        maxWidth="xs"
        sx={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <Rocket style={{ width: 84 }} />
        </Box>
        <Box paddingLeft={3} paddingRight={3} marginBottom={5}>
          <Typography
            color={"#D4D4D8"}
            fontWeight={700}
            fontSize={20}
            textAlign="center"
          >
            {/* {t("accountReview")} */}
          {t("verificationProgress")}

          </Typography>
          <Typography
            variant="subtitle1"
            color={"#D4D4D8"}
            fontSize={16}
            fontWeight={400}
            marginTop={1}
            textAlign="center"
          >
            {t("accountReviewText")}
          </Typography>
        </Box>
        <AppButton
          title={t("contact")}
          href={config.ZENDESK_SUPPORT}
          target="_blank"
        />
        <AppButton
          title={t("back")}
          buttontheme={'transparent'}
          onClick={() => navigate('/home')}
        />
      </Container>
    </AppDialog>
  );
}
